import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Box } from '@curves/ui-base';

import * as echarts from "echarts/core";
import { LineChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, DatasetComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { isEmpty } from "@Util/utils";
import { chartColorMap } from "@Local/Dashboard/staticData";
echarts.use([LineChart, GridComponent, TooltipComponent, LegendComponent, DatasetComponent, CanvasRenderer]);
const LineChartBox = React.forwardRef((props, ref) => {
    const {
        tooltip = { trigger: 'axis' },
        grid = { left: "5%", right: "3%" },
        xAxis = { type: 'category' },
        yAxis = { type: 'value' },
        style,
        others = {},
        dark: darkProps
    } = props;
    let option = {
        color: chartColorMap,
        legend: {},
        tooltip,
        grid,
        dataset: { source: [] },
        xAxis,
        yAxis,
        series: [],
        ...others,
    };
    const [chartInstance, setChartInstance] = useState(null);
    const [sourceData, setSourceData] = useState(null);
    const chartRef = useRef(null);
    useImperativeHandle(ref, () => ({
        setSource: (source) => {
            setSourceData(source);
        },
        triggerResize: (width, height) => {
            chartRef.current.style.width = width;
            chartRef.current.style.height = height;
            if (chartInstance) {
                chartInstance.resize(); // 根據容器大小自適應
            }
        }
    }));
    useEffect(
        () => {
            if (!chartInstance || isEmpty(sourceData)) return;
            chartInstance.clear();
            option.dataset.source = sourceData;
            const seriesResult = []
            let index = 1;
            while (index < sourceData[0].length) {
                seriesResult.push({ type: 'line', name: sourceData[0][index], encode: { x: 'category', y: sourceData[0][index] } });
                index++;
            }
            option.series = seriesResult;
            chartInstance.setOption(option);
        },
        // eslint-disable-next-line
        [sourceData]
    );
    useEffect(
        () => {
            if (!chartRef.current) return;
            const instance = echarts.init(chartRef.current, darkProps ? "dark" : "light");
            setChartInstance(instance);
            return () => {
                instance.dispose();
            };
        },
        // eslint-disable-next-line
        []
    );
    return <Box ref={chartRef} style={style}></Box>;
});
export default LineChartBox;